import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    since: String,
    seconds: Number,
    format: { type: String, default: "mm:ss" },
    warningThreshold: Number,
    dangerThreshold: Number,
  }
  static targets = ["display", "retryButton"]
  static classes = ["normal", "warning", "danger"]

  get displayElement() {
    return this.hasDisplayTarget ? this.displayTarget : this.element
  }

  connect() {
    if (this.hasSecondsValue) {
      this.displayElement.textContent = this.formatElapsed(this.secondsValue)
    } else if (this.hasSinceValue) {
      this.update()
      this.interval = setInterval(() => this.update(), 1000)
    }
  }

  disconnect() {
    if (this.interval) clearInterval(this.interval)
  }

  update() {
    const since = new Date(this.sinceValue)
    const elapsedSeconds = Math.max(0, Math.floor((Date.now() - since) / 1000))
    this.displayElement.textContent = this.formatElapsed(elapsedSeconds)

    if (elapsedSeconds >= 120 && this.hasRetryButtonTarget) {
      this.retryButtonTarget.classList.remove("hidden")
    }

    this.updateSlaClasses(elapsedSeconds)
  }

  updateSlaClasses(elapsedSeconds) {
    if (!this.hasDangerThresholdValue || !this.hasNormalClass) return

    const el = this.element
    const cellTint = el.closest("[data-sla-cell-tint]")

    if (elapsedSeconds >= this.dangerThresholdValue) {
      el.classList.remove(...this.normalClasses, ...this.warningClasses)
      el.classList.add(...this.dangerClasses)
      this.applyCellTint(cellTint, "danger")
    } else if (
      this.hasWarningThresholdValue &&
      elapsedSeconds >= this.warningThresholdValue
    ) {
      el.classList.remove(...this.normalClasses, ...this.dangerClasses)
      el.classList.add(...this.warningClasses)
      this.applyCellTint(cellTint, "warning")
    } else {
      el.classList.remove(...this.warningClasses, ...this.dangerClasses)
      el.classList.add(...this.normalClasses)
      this.applyCellTint(cellTint, "normal")
    }
  }

  applyCellTint(el, state) {
    if (!el) return

    const warning = (el.dataset.slaCellTintWarningClass || "").split(/\s+/).filter(Boolean)
    const danger = (el.dataset.slaCellTintDangerClass || "").split(/\s+/).filter(Boolean)

    if (state === "danger") {
      el.classList.remove(...warning)
      el.classList.add(...danger)
    } else if (state === "warning") {
      el.classList.remove(...danger)
      el.classList.add(...warning)
    } else {
      el.classList.remove(...warning, ...danger)
    }
  }

  formatElapsed(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600)
    const minutes = Math.floor((totalSeconds % 3600) / 60)
    const seconds = totalSeconds % 60
    const pad = (n) => String(n).padStart(2, "0")

    if (this.formatValue === "hh:mm:ss") {
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`
    }
    return `${pad(minutes + hours * 60)}:${pad(seconds)}`
  }
}
